export interface Doctor {
    egd_users: {
        user_guid: string;
        first_name: string;
        middle_name: string;
        last_name: string;
        state_name: string;
        avatar_url: string;
        country: {
            country_name: string;
        };
    };
    speciality: {
        specialty_name: string;
    };
    salutation?: string;
}

export interface Roles {
    id: number;
    title: string;
}

export interface ResetSystemPassword {
    user_guid: string;
    password: string;
    confirm_password: string;
    prev_password: string;
}

export interface ProfileCardData {
    avatar_url: string;
    name: string;
    occupation: string;
    country: string;
    user_guid: string;
}

export class fetchAllData {
    specialty_id: number[] = [];
    country_id: number[] = [];
    state_id: number[] = [];
    is_diet: boolean = null;
    provider_id: string = '';
}

export class MessagesEgdUserQuery {
    country_id?: number;
    specialty_id?: string;
    is_doctor?: boolean;
    has_schedules?: boolean;
    is_dietician?: boolean;
}
export interface CertificateData
{
    document_name: string;
    document_url: string;
    expires_on: string;
}
